import React from 'react';
import './Features.css';

const Features = () => {
  return (
    <section className="features" id="features">
      <div className="container">
        <h2 className="section-title">Jak MINERVA transformuje przemysł</h2>
        <p className="section-subtitle">
          Nasza platforma wprowadza przełomowe rozwiązania technologiczne, które radykalnie 
          poprawiają wydajność procesów i redukują koszty operacyjne
        </p>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-wrapper ai-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
              </div>
            </div>
            <h3>Automatyczne podejmowanie decyzji</h3>
            <p>Inteligentna analiza i optymalizacja procesów w czasie rzeczywistym zwiększająca wydajność produkcji o 18%.</p>
            <ul className="feature-benefits">
              <li>Predykcyjna analityka awarii</li>
              <li>Automatyczne dostosowanie parametrów</li>
              <li>Redukcja przestojów o 32%</li>
            </ul>
            <a href="#contact" className="feature-link">
              Dowiedz się więcej
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-wrapper llm-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </div>
            </div>
            <h3>Sztuczna inteligencja LLM</h3>
            <p>Wykorzystanie dużych modeli językowych (LLM) do inteligentnej analizy kontekstowej i rozwiązywania złożonych problemów.</p>
            <ul className="feature-benefits">
              <li>Zaawansowana analiza danych tekstowych i liczbowych</li>
              <li>Automatyczne generowanie raportów i zaleceń</li>
              <li>Wsparcie decyzji poprzez interpretację trendów</li>
            </ul>
            <a href="#contact" className="feature-link">
              Dowiedz się więcej
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-wrapper ecosystem-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="4"></circle>
                  <line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line>
                  <line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line>
                  <line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line>
                  <line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line>
                  <line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>
                </svg>
              </div>
            </div>
            <h3>Zintegrowany ekosystem</h3>
            <p>Kompleksowa platforma umożliwiająca centralne zarządzanie i redukcję kosztów operacyjnych o 22%.</p>
            <ul className="feature-benefits">
              <li>Pełna integracja z istniejącą infrastrukturą</li>
              <li>Zarządzanie z jednego panelu administracyjnego</li>
              <li>Skalowalność od małych do dużych przedsiębiorstw</li>
            </ul>
            <a href="#contact" className="feature-link">
              Dowiedz się więcej
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-wrapper reaction-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
              </div>
            </div>
            <h3>Błyskawiczna reakcja</h3>
            <p>Skrócenie czasu reakcji o 75% dzięki zdecentralizowanej analizie danych zapobiegającej awariom.</p>
            <ul className="feature-benefits">
              <li>Czas reakcji poniżej 50ms</li>
              <li>Automatyczne procedury naprawcze</li>
              <li>Prewencyjne wykrywanie anomalii</li>
            </ul>
            <a href="#contact" className="feature-link">
              Dowiedz się więcej
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          </div>
        </div>
        
        <div className="features-cta">
          <a href="#architecture" className="button button-primary">Zobacz architekturę systemu</a>
        </div>
      </div>
    </section>
  );
};

export default Features;